import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import Pagination from '../../../components/common/Pagination';
import VisitNoteCard from './VisitNoteCard';

export default class VisitNotesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { page: 0, pageSize: 25 };
  }

  componentWillMount() {
    this.refs = {}; // unfreeze object for hack
    if (this.props.page > 0) {
      this.setState({ page: this.props.page });
    }
    if (this.props.perPage > 0) {
      this.setState({ pageSize: this.props.perPage });
    }
  }

  fetchData = (state, instance) => {
    return setTimeout(
      () =>
        this.props.fetchData(this.state.page, state.pageSize).then(res => {
          if (this.refs.notesList) {
            this.setState({
              pageSize: state.pageSize,
            });
          }
        }),
      0,
    );
  };

  getTdProps = (state, rowInfo, column, instance) => {
    return {
      onClick: (e, handleOriginal) => {
        if (!rowInfo) {
          return;
        }
        if (
          this.props.selected &&
          rowInfo.original.visitNoteID === this.props.selected.visitNoteID
        ) {
          this.props.selectNote(null);
        } else if (rowInfo) {
          this.props.selectNote(rowInfo.original);
        }
        if (handleOriginal) {
          handleOriginal();
        }
      },
      style: {
        background:
          rowInfo &&
          this.props.selected &&
          rowInfo.original.visitNoteID === this.props.selected.visitNoteID
            ? 'rgba(0,0,0,.13)'
            : '',
      },
    };
  };

  render() {
    const { limits, simpleView, search } = this.props;
    const columns = [
      {
        Cell: row => (
          <VisitNoteCard
            ref={el => (this.refs[row.original.visitNoteID] = el)} // hack
            info={row.original}
            limits={limits}
            simpleView={simpleView}
          />
        ),
        accessor: 'visitNoteID',
      },
    ];
    return (
      <ReactTable
        manual
        ref="notesList"
        defaultPageSize={this.state.pageSize}
        search={search}
        page={this.state.page}
        onPageChange={pageIndex => this.setState({ page: pageIndex })}
        pages={
          this.props.data
            ? Math.ceil(this.props.data.total / this.state.pageSize)
            : 0
        }
        minRows={5}
        loading={this.props.isLoading}
        onFetchData={this.fetchData}
        data={
          this.props.data && this.props.data.list ? this.props.data.list : []
        }
        onSearchChange={this.props.onSearchChange}
        columns={columns}
        getTdProps={this.getTdProps}
        className="-striped -highlight visit-notes-list-table"
        showPaginationTop={true}
        PaginationComponent={Pagination}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/management/components/VisitNotesList.js